<template>
  <div class="dashboard-container">
    <!-- 상단 헤더 -->
    <header class="dashboard-header">
      <span class="logo">마이바버샵 파트너스</span>
      <div class="user-area">
      <div class="user-info">
          <span class="nickname">{{ nickname }} 님</span>
          <button @click="logout">로그아웃</button>
      </div>    
  </div>

    </header>

    <router-link
      v-if="isAdmin"
      to="/superadmin"
      class="superadmin-link"
    >
      🧑‍💼 총괄 관리자 페이지
    </router-link>

    <!-- 새 알림, 공지사항 섹션 -->
    <section class="dashboard-content">
      <!-- ... 알림/공지 내용 ... -->
    </section>

    <!-- ✅ 여기! 우리 매장 섹션 -->
    <section class="our-shops">
      <h2>우리 매장 <span class="count">{{ shops?.length || 0 }}</span>곳</h2>

      <!-- ✅ 카드형 매장 리스트 -->
      <div v-if="shops.length > 0" class="shop-cards">
        <div
          class="shop-card"
          v-for="shop in shops"
          :key="shop._id"
          @click="goToDetail(shop)"
        >
          <h3 class="shop-name">{{ shop.name }}</h3>
          <p class="shop-address">{{ shop.address || '주소 정보 없음' }}</p>
          <p class="shop-meta">등록일: {{ formatDate(shop.createdAt) }}</p>
        </div>
      </div>
      
      <div v-else>
        <p>아직 노출중인 매장이 없네요.</p>
        <p>매장을 등록하고 마이바버샵에서 매장을 노출해보세요!</p>
        <!--<button @click="goToRegister">매장등록</button>-->
      </div>
      <!-- ✅ 버튼을 완전히 바깥 div로 -->
       <!-- 추후 이거 풀어줌..  매장 추가 방지 20250605-->
      <!--<div class="add-shop-button-container"  v-if="shops.length === 0">-->
      <div class="add-shop-button-container"  >
        <button @click="goToRegister" class="add-shop-button">매장 추가</button>
      </div>
    </section>
  </div>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      user: {},
      nickname: "게스트",
      shops: [],
      isAdmin: false,
    };
  },
  created() {
    const storedUser = JSON.parse(localStorage.getItem("user")) || {};
    this.user = storedUser;
    this.nickname = storedUser.nickname || "게스트";
    this.isAdmin = storedUser.kakaoId === 4250089077; // ✅ 카카오 ID 기준 관리자 판단
    this.fetchShops(); // ✅ 반드시 호출
  },
  mounted() {
    this.fetchShops();
  },
  methods: {
          formatDate(dateStr) {
        if (!dateStr) return '-';
        const date = new Date(dateStr);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}.${mm}.${dd}`;
      },
    async fetchShops() {
      try {
        // 기존 소스 20251214
        //const storedUser = JSON.parse(localStorage.getItem("user")) || {};
        //const userId = storedUser.kakaoId || storedUser.userId || '';

        // ✅ 이 부분이 핵심 수정 포인트입니다.
        // localStorage에서 'kakao_...' 또는 'naver_...' 형태의 통합 ID를 직접 가져옵니다.
        const userId = localStorage.getItem('userUUID') || '';

        if (!userId) {
          console.warn("❌ userId 없음, 매장 불러오기 생략");
          return;
        }

        const apiUrl = `${process.env.VUE_APP_API_BASE_URL}/api/barbershops/partner/shops?userId=${userId}`;
        
        console.log("✅ 요청 URL:==============", apiUrl);
        console.log("✅ 요청 userId:==========", userId);

        //const res = await axios.get(apiUrl);
        const res = await axios.get(apiUrl, {
         headers: { 'Cache-Control': 'no-cache' }
        });
        this.shops = Array.isArray(res.data) ? res.data : (res.data.shops || []);
        console.log("✅ 내 매장 불러오기 성공:=============", this.shops);
      } catch (err) {
        console.error("❌ 매장 조회 실패:", err);
      }
    },
    goToRegister() {
      this.$router.push("/register");
    },
    goToDetail(shop) {
      console.log("clicked", shop);
      this.$router.push({ name: "ShopDetailView", params: { id: shop.id } });
    },
    logout() {
      localStorage.removeItem("user");
      caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
      this.$router.push("/");
    },
  },
};
</script>



<style scoped>
.user-info {
  display: flex;
  align-items: center;
  gap: 12px; /* ✅ 버튼과 닉네임 사이 여백 */
}
.nickname {
  margin-right: 12px; /* ← 여백 설정 */
}

.logout-button {
  white-space: nowrap;
}

.count {
  color: #6c3bd1;
  font-weight: bold;
}
.dashboard-header {
  display: flex;
  justify-content: space-between; /* ✅ 좌우 정렬 */
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 10px 20px;
}

.user-area {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dashboard-container {
  padding: 20px;
  font-family: "Noto Sans KR", sans-serif;
  color: #333;
}

.logo {
  height: 30px;
}
.user-info {
  font-size: 14px;
}
.dashboard-content {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.notifications {
  width: 40%;
}
.announcements {
  width: 58%;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.notice-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}
.badge {
  background: #888;
  color: white;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 3px;
  margin-right: 5px;
}
.dashboard-footer {
  margin-top: 40px;
  text-align: center;
}
.our-shops {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
}
/*
.our-shops button {
  background: #6c3bd1;
  color: white;
  border: none;
  padding: 10px 20px;
  font-weight: bold;
  border-radius: 20px;
  margin-top: 15px;
  cursor: pointer;
}
*/

.count {
  color: #6c3bd1;
  font-weight: bold;
}



.shop-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.shop-item {
  padding: 12px 16px;
  border-top: 1px solid #eee;
  cursor: pointer;
  transition: background 0.2s;
}

.shop-item:first-child {
  border-top: none;
}
.shop-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
}

.shop-card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
  width: calc(50% - 8px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
}

.shop-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

.shop-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}

.shop-address {
  font-size: 13px;
  color: #666;
}

@media (max-width: 768px) {
  .shop-card {
    width: 100%;
  }
}
.add-shop-button-container {
  margin-top: 24px;
  text-align: right; /* 또는 center, left */
}


.add-shop-button {
  display: inline-block;
  padding: 12px 20px;
  background-color: #007BFF; /* <-- 제안 2의 파란색 적용 */
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: bold;
  transition: background-color 0.2s; /* 부드러운 색상 변경 효과 */
}

.add-shop-button:hover {
   background-color: #0056b3; /* ✅ 더 진한 파란색으로 변경 */
}

.shop-meta {
  font-size: 12px;
  color: #888;
  margin-top: 6px;
}

.superadmin-link {
  display: inline-block;
  margin: 16px 0;
  padding: 10px 20px;
  background-color: #ff9800;
  color: white;
  border-radius: 6px;
  font-weight: bold;
  text-decoration: none;
}
.superadmin-link:hover {
  background-color: #e68900;
}
</style>
